import React from "react";
import { TwelveMonthExpenseChart } from "./TwelveMonthExpenseChart";
import { TwelveMonthExpenseInsightsPanel } from "./TwelveMonthExpenseInsightsPanel";
import { useTwelveMonthExpenseTrend } from "../../hooks/useTwelveMonthExpenseTrend";
import { useTwelveMonthExpenseInsights } from "../../hooks/useTwelveMonthExpenseInsights";

export function TwelveMonthExpenseTrendSection() {
  const {
    labels,
    values,
    averageExpense,
    averageLabel,
    rangeLabel,
    loading,
    error,
  } = useTwelveMonthExpenseTrend();

  const insightsData = useTwelveMonthExpenseInsights({
    enabled: !loading && !error,
  });

  const effectiveRange = insightsData.rangeLabel || rangeLabel || "";
  const sectionSubtext = effectiveRange
    ? `${effectiveRange} · Closed months only`
    : "Closed months only";
  /** Insights panel: range only + label (no month count). */
  const displayRangeLabel = effectiveRange;

  const insightsPanelLoading = loading || insightsData.loading;

  return (
    <div className="flex w-full flex-col items-start gap-8">
      <div className="flex w-full items-center justify-between gap-4">
        <div className="flex min-w-0 items-center gap-2 border-l-4 border-solid border-neutral-900 pl-2">
          <span className="text-heading-3 font-heading-3 text-neutral-900 uppercase tracking-wider">
            Monthly trend
          </span>
        </div>
        <span className="text-caption font-caption text-neutral-500 shrink-0 text-right">
          {sectionSubtext}
        </span>
      </div>
      {error && (
        <p className="text-caption font-caption text-red-600" role="alert">
          {error}
        </p>
      )}
      <div className="flex w-full min-h-[280px] min-w-0 rounded-lg border border-solid border-neutral-200 bg-white shadow-md items-stretch">
        <TwelveMonthExpenseChart
          labels={labels}
          values={values}
          average={averageExpense}
          averageLabel={averageLabel}
          rangeLabel={rangeLabel || undefined}
          loading={loading}
        />
        <div className="flex w-px flex-none flex-col items-start bg-neutral-200" />
        <TwelveMonthExpenseInsightsPanel
          rangeLabel={displayRangeLabel}
          insights={insightsData.error ? [] : insightsData.insights}
          loading={insightsPanelLoading}
        />
      </div>
    </div>
  );
}
